import { Button } from '../../../../components/Form/Button';

interface Props {
  handlePrevious: () => void;
  handleNext: () => void;
  totalResults: number;
  currentPage: number;
  pageSize: number;
}

const CardFooter = ({
  handlePrevious,
  handleNext,
  totalResults,
  currentPage,
  pageSize,
}: Props) => {
  const max = pageSize * currentPage;
  const min = max - pageSize + 1;
  return (
    <nav
      aria-label='Pagination'
      className='flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6'
    >
      <div className='hidden sm:block'>
        <p className='text-sm text-gray-700'>
          Showing <span className='font-medium'>{min}</span> to{' '}
          <span className='font-medium'>{max}</span> of{' '}
          <span className='font-medium'>{totalResults}</span> results
        </p>
      </div>
      <div className='flex flex-1 justify-between sm:justify-end'>
        <Button
          type='button'
          onClick={handlePrevious}
          variant='outline'
          disabled={currentPage === 1}
          className='w-1/4 mr-2'
        >
          Previous
        </Button>
        <Button
          type='button'
          onClick={handleNext}
          variant='primary'
          disabled={totalResults <= max}
          className='w-1/4'
        >
          Next
        </Button>
      </div>
    </nav>
  );
};
export default CardFooter;
